<script lang="ts" setup>
import { formatNumber } from '@/home/utils/format';

const props = defineProps({
  data: {
    type: Object,
    default: () => {},
  },
})
</script>

<template>
  <RouterLink :to="`/explore/journalism/detail/${props.data?.informationId}`" target="_blank">
    <div class="group w-100% border-b-1 border-hex-e3e3e3 border-solid bg-hex-fff p-16 hover:bg-hex-fafafa">
      <div class="flex-y-center">
        <span class="text-12 text-hex-292929 font-400 leading-20" v-if="props.data.informationType == '1'">
          <span>{{ $t('home.common.prime') }}</span>
          <span class="mx-4 text-hex-adadad">|</span>
        </span>
        <span class="text-12 text-hex-adadad font-400 leading-20">{{ $t('home.content.title5') }}</span>
        <span v-for="(item, index ) in props.data.labelNameList" :key="item" class="text-12 text-hex-adadad font-400 leading-20">
          <span class="mx-4" v-if="index === 0">|</span>
          <span class="mx-4" v-else>·</span>
          <span>{{ item.labelName }}</span>
        </span>
      </div>

      <div class="flex justify-between">
        <div class="w-610">
          <div class="flex">
            <h3 class="article-title line-clamp-1 mt-4 break-anywhere text-16 color-hex-292929 font-500 leading-24 group-hover:underline" :title=" props.data.informationTitle">{{ props.data.informationTitle }}</h3>
          </div>
          <p class="line-clamp-1 mt-4 break-anywhere text-justify text-14px color-hex-575757 font-400 leading-22">{{ props.data.informationMsg }}</p>
          <div class="mt-8 flex-y-center gap-24">
            <div class="flex-y-center gap-4 text-12 text-hex-575757 font-400">
              <span class="i-icons:eye-outlined size-16"></span>
              <span class="leading-16">{{ formatNumber(props.data.informationViews) }}</span>
            </div>

            <div class="flex-y-center gap-4 text-12 text-hex-575757 font-400">
              <span class="i-icons:good size-16"></span>
              <span class="leading-16">{{ formatNumber(props.data.informationLikeNum) }}</span>
            </div>

            <div class="flex-y-center gap-4 text-12 text-hex-575757 font-400">
              <span class="i-icons:favorite size-16"></span>
              <span class="leading-16">{{ formatNumber(props.data.informationCollectNum) }}</span>
            </div>
          </div>
        </div>
        <div class="h-78 w-134">
          <img :data-src="props.data.informationUrl" :alt="props.data.informationTitle" class="lozad size-full rounded-4 bg-hex-f7f7f7 object-contain">
        </div>
      </div>
    </div>
  </RouterLink>
</template>

<style lang="scss" scoped>
</style>
